import { supabase } from "../lib/supabase";
import { getDateRangeBounds, toUTCStartEnd } from "../utils/dateUtils";

// Fetches billable spend for an advertiser over an MTD window (first of current month → today).
// Returns { spendSum, error } — spendSum defaults to 0 on missing data or error.
export async function fetchMTDSpend(advertiserId) {
  if (!supabase) {
    return { spendSum: 0, error: new Error("Supabase not configured") };
  }
  try {
    const { startDate, endDate } = getDateRangeBounds("MTD", null, null);
    const { startISO, endISO } = toUTCStartEnd(startDate, endDate);
    const { data, error } = await supabase.rpc("get_billable_conversions_stats", {
      p_advertiser_id: advertiserId,
      p_start_at: startISO,
      p_end_at: endISO,
    });
    if (error) return { spendSum: 0, error };
    const row = Array.isArray(data) && data.length ? data[0] : data;
    const spendSum = (row && typeof row.spend_sum === "number") ? row.spend_sum : 0;
    return { spendSum, error: null };
  } catch (error) {
    return { spendSum: 0, error: error instanceof Error ? error : new Error("Failed to load MTD spend") };
  }
}
